
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9.91","height":"15.857"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon metro-location","d":"M4.955 0A4.955 4.955 0 000 4.955c0 4.955 4.955 10.9 4.955 10.9S9.91 9.909 9.91 4.955A4.955 4.955 0 004.955 0zm0 7.99A3.035 3.035 0 117.99 4.955 3.035 3.035 0 014.955 7.99zm-1.92-3.035a1.92 1.92 0 111.92 1.917 1.92 1.92 0 01-1.92-1.917z","fill":"#898888"}})])
          )
        }
      }
    